@defer (when !isVertical()) {
  <div class="flex items-center gap-lg" [id]="stepperId()">
    @if (options().length > visibleOptions()) {
      <button
        type="button"
        (click)="scrollLeft()"
        [class.opacity-30]="index() === 0"
        [disabled]="index() === 0"
        class="z-1">
        <lib-circle-arrow-left-icon [iconClass]="'size-6 text-neutral-500'" />
      </button>
    }

    <div class="horizontal-container">
      <div
        class="horizontal relative flex"
        [class.horizontal-scroll]="options().length > visibleOptions()"
        [style.width]="
          options().length > visibleOptions()
            ? 'max-content'
            : '100%'
        ">
        @for (
          option of options();
          track $index;
          let last = $last;
          let first = $first;
          let i = $index
        ) {
          <div
            class="options"
            [style.width]="
              !isCentered() && first ? 'calc(10vw)' : 'calc(19vw)'
            ">
            <div class="icon">
              @if (!first) {
                <div
                  [class.bg-primary-500]="options()[i - 1].status === 'done'"
                  class="line bg-neutral-200"></div>
              } @else {
                <div class="line"></div>
              }

              <lib-step-status-icon
                [status]="option.status || 'inactive'"
                [iconClass]="'size-8 rounded-full'" />

              @if (!last) {
                <div
                  [class.bg-primary-500]="
                    options()[i + 1].status !== 'inactive'
                  "
                  class="line bg-neutral-200"></div>
              } @else {
                <div class="line"></div>
              }
            </div>

            <div
              class="mt-sm relative"
              [class.px-xl]="isCentered() && !(first || last)">
              <p
                class="text-base text-neutral-900 flex items-center cursor-pointer"
                (click)="option.isParallel ? showSteps(option, $index) : ''">
                <span
                  #stepperLabel
                  class="font-medium text-center break-words max-w-full whitespace-normal min-w-0"
                  [class.me-sm]="option.isParallel">
                  {{ option.label }}
                </span>

                @if (option.isParallel) {
                  @let isSwitched =
                    isShowParallelSteps() && option.position === clickedStep();
                  <span class="flex">
                    <lib-solid-arrow-down-icon
                      [iconClass]="
                        'size-5 text-neutral-600 ' +
                        (isSwitched ? 'rotate-180' : '')
                      " />
                  </span>
                }
              </p>

              @if (isShowParallelSteps() && option.position === clickedStep()) {
                <lib-tooltip
                  [toolTipClass]="'bg-white py-2xl px-lg rounded-lg shadow-lg w-[20rem] !-start-[50%]'"
                  [title]="'stepper_tooltip_title' | transloco"
                  [position]="'absolute'"
                  [hasCloseIcon]="true"
                  (handleClose)="isShowParallelSteps.set(false)"
                  [top]="'28px'"
                  [left]="'-140%'"
                  [toolTipTemplate]="toolTipTemplate"
                  [placement]="'right'">
                  <ng-template #toolTipTemplate>
                    <div class="parallel-steps-scroll">
                    @for (
                      item of option.parallelSteps;
                      track $index;
                      let i = $index
                    ) {
                      <div class="pt-lg pb-sm border-b border-neutral-200">
                        <div class="flex justify-between">
                          <p
                            class="text-xs text-start text-neutral-700 font-semibold mb-md text-center trim-text"
                            libTrimTooltip
                            placement="top"
                            [toolTipClass]="'bg-white p-md rounded-lg shadow-lg tooltip-arrow tooltip-arrow-top request-details-tooltip cursor-pointer'"
                            [trimLength]="30"
                            [fullText]="item.label || ''">
                          </p>

                          <lib-badge
                            [label]="item.badge || '' | transloco"
                            badgeClass="px-sm border-none text-xs font-medium {{
                              item.badge_class
                            }}"></lib-badge>
                        </div>

                        @if (item.description) {
                          <div class="flex items-center gap-md">
                            <lib-avatar
                              [fullName]="item.description"
                              [img]="item.icon || ''"
                              [size]="''"
                              [imgDimensions]="{ width: 24, height: 24 }"
                              [placeholderTextClass]="'text-xs font-medium'"
                              [borderRadius]="'rounded-full'" />

                            <span class="text-xs font-medium text-neutral-900">
                              {{ item.description }}
                            </span>
                          </div>
                        }

                        <!-- If there is only one assignee -->
                        @if (
                          item.descriptionIconArray &&
                          item.descriptionIconArray.length === 1
                        ) {
                          @let assignee =
                            item.descriptionIconArray
                              ? item.descriptionIconArray[0]
                              : null;
                          @if (assignee) {
                            <div class="flex items-center gap-md">
                              <lib-avatar
                                [fullName]="assignee.name"
                                [img]="assignee.image?.url || ''"
                                [size]="''"
                                [imgDimensions]="{ width: 24, height: 24 }"
                                [placeholderTextClass]="'text-xs font-medium'"
                                [borderRadius]="'rounded-full'" />

                              <span
                                class="text-xs font-medium text-neutral-900"
                                libTrimTooltip
                                placement="top"
                                [toolTipClass]="'bg-white p-md rounded-lg shadow-lg tooltip-arrow tooltip-arrow-top request-details-tooltip cursor-pointer'"
                                [trimLength]="32"
                                [fullText]="assignee.name">
                              </span>
                            </div>
                          }
                        }

                        <!-- If there are multiple assignees, show the assignee template -->
                        @if (
                          item.descriptionIconArray &&
                          item.descriptionIconArray.length > 1
                        ) {
                          @let assigneeArray = item.descriptionIconArray;
                          <ng-container
                            [ngTemplateOutlet]="assigneeTemplate()"
                            [ngTemplateOutletContext]="{
                              $implicit: assigneeArray,
                              i: i,
                            }" />
                        }
                      </div>
                    }
                    </div>
                  </ng-template>
                </lib-tooltip>
              }
            </div>
          </div>
        }
      </div>
    </div>

    @if (options().length > visibleOptions()) {
      <button
        type="button"
        (click)="scrollRight()"
        [class.opacity-30]="isRightScrollDisabled()"
        [disabled]="isRightScrollDisabled()"
        class="z-1">
        <lib-circle-arrow-left-icon
          [iconClass]="'size-6 text-neutral-500 rotate-180'" />
      </button>
    }
  </div>
}

@defer (when isVertical()) {
  <div class="flex flex-col items-start">
    @for (
      option of options();
      track $index;
      let first = $first;
      let last = $last;
      let i = $index
    ) {
      <div
        class="flex w-full items-center"
        [class.active-step]="option.status === 'active'">
        <div class="flex flex-col items-center self-stretch px-lg">
          <div
            class="w-[0.125rem] min-h-4 flex-1"
            [class.bg-transparent]="first"
            [class.bg-primary-500]="
              !first && options()[i - 1].status === 'done'
            "
            [class.bg-neutral-200]="
              !first && options()[i - 1].status !== 'done'
            "></div>

          <lib-step-status-icon
            [status]="option.status || 'inactive'"
            [iconClass]="'size-8 rounded-full'" />
          <div
            class="w-[0.125rem] min-h-4 flex-1"
            [class.bg-transparent]="last"
            [class.bg-primary-500]="!last && option.status === 'done'"
            [class.bg-neutral-200]="!last && option.status !== 'done'"></div>
        </div>
        <div
          [class.pb-4]="first"
          [class.py-4]="!first && !last"
          [class.pt-4]="last"
          class="ms-2">
          <p class="text-base text-neutral-900 font-medium">
            {{ option.label }}
          </p>

          @if (descriptionTemplate()) {
            <ng-container
              [ngTemplateOutlet]="descriptionTemplate()"
              [ngTemplateOutletContext]="{
                $implicit: option.descriptionTemplateData,
              }" />
          } @else if (option.description) {
            <p class="text-sm text-neutral-500">{{ option.description }}</p>
          }
        </div>
      </div>
    }
  </div>
}
